import React, {Component} from "react";
import {Modal, ModalHeader, ModalTitle, ModalClose, ModalBody, ModalFooter} from "react-modal-bootstrap";
import CoreService from "../service/CoreService";

class DispatchedModal extends Component {
    constructor() {
        super();

        this.state = {
            dispatcherId: null,
            modal: {
                open: false,
                hasCloseButton: true,
                closeButtonText: 'Close',
                hasFooter: true,
                hasSaveButton: true,
                saveButtonText: '',
                title: '',
                body: ''
            }
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.confirmModal = this.confirmModal.bind(this);
    }

    componentDidMount() {
        this.setState({
            dispatcherId: CoreService.dispatcher.register(dispatch => {
                if (dispatch.type === 'modal' && dispatch.target === this.props.modalId) {
                    if (this.state.modal.open && false === dispatch.options.open) {
                        // trigger onHide when transitioning from open->closed
                        this.closeModal();
                    }
                    this.setState({modal: dispatch.options})
                }
            })
        });
    }

    componentWillUnmount() {
        if (this.state.dispatcherId) {
            CoreService.dispatcher.unregister(this.state.dispatcherId);
        }
    }

    openModal() {
        this.setState({
            modal: {
                open: true
            }
        });
    }

    afterOpenModal() {
    }

    closeModal() {
        if (typeof this.state.modal.onHide === 'function') {
            this.state.modal.onHide();
        }
        this.setState({
            modal: {
                open: false
            }
        });
    }

    confirmModal() {
        if (typeof this.state.modal.onConfirm === 'function') {
            this.state.modal.onConfirm();
        }
        this.closeModal();
    }

    render() {
        return (
            <Modal isOpen={this.state.modal.open} onRequestHide={this.closeModal} backdrop={false}>
                <ModalHeader>
                    {this.state.modal.hasCloseButton &&
                    <ModalClose onClick={this.closeModal}/>}
                    <ModalTitle>{this.state.modal.title}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {this.state.modal.body}
                </ModalBody>
                {this.state.modal.hasFooter &&
                <ModalFooter>
                    <button className='btn btn-default' onClick={this.closeModal}>
                        {this.state.modal.closeButtonText}
                    </button>
                    {this.state.modal.hasSaveButton &&
                    <button className='btn btn-primary' onClick={this.confirmModal}>
                        {this.state.modal.saveButtonText}
                    </button>}
                </ModalFooter>}
            </Modal>
        );
    }
}

DispatchedModal.propTypes = {
    modalId: React.PropTypes.string.isRequired
};

export default DispatchedModal;



// WEBPACK FOOTER //
// ./src/modules/common/DispatchedModal.js